import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class RoleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: [],
      formData: {
        name: '',
        selectedPermissions: [],
      },
      loading: false,
      isLoad: true,
      expandedCategories: {},
    }
  }

  async componentDidMount() {
    this.getRoleInfo();
    this.getPermissions();
  }
  getPermissions = async () => {
    const response = await apiCall('business/settings/role/get-permissions', 'get', null);
    this.setState({ permissions: response }, () => {
      this.setState({ isLoad: false });
    });
  }

  getRoleInfo = async () => {
    const { id } = this.props.match.params;
    try {
      const response = await apiCall(`business/settings/role/info/${id}`, 'get', null);
      const updatedData = { ...this.state.formData };

      updatedData.name = response.name && response.name.split('_')[0];
      updatedData.selectedPermissions = response.permissions.map(permission => permission.id) || [];

      this.setState({ formData: updatedData });
    } catch (error) {
      this.setState({ isLoad: false });
      console.error('Error fetching role info:', error);
    }
  }

  handleCheckboxChange = (permissionId, isChecked) => {
    const { formData } = this.state;
    const selectedPermissions = isChecked
      ? [...formData.selectedPermissions, permissionId]
      : formData.selectedPermissions.filter(id => id !== permissionId);

    this.setState({
      formData: {
        ...formData,
        selectedPermissions,
      },
    });
  }

  handleChance = (e) => {
    const { id, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value,
      }
    }));
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { id } = this.props.match.params;
    const { formData } = this.state;
    try {
      const response = await apiCall('business/settings/role/update/' + id, 'post', formData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  toggleCategory = (category) => {
    this.setState(prevState => ({
      expandedCategories: {
        ...prevState.expandedCategories,
        [category]: !prevState.expandedCategories[category],
      }
    }));
  }

  render() {
    const { formData, loading, permissions, expandedCategories } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateRolePermission = userPermissions.includes('update role');
    const groupedPermissions = permissions.reduce((acc, permission) => {
      if (!acc[permission.category]) {
        acc[permission.category] = [];
      }
      acc[permission.category].push(permission);
      return acc;
    }, {});

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Servis tipi detayı"
              Breadcrumb={[
                { name: "Yetkiler", navigate: "roles" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              id="name"
                              className="form-control"
                              placeholder="Ad"
                              type="text"
                              disabled={formData.name === 'Admin'}
                              value={formData.name || ''}
                              onChange={this.handleChance}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="body">
                      <div className="row clearfix">
                        <ul className="list-unstyled feeds_widget col-lg-12">
                          {Object.keys(groupedPermissions).map((category, index) => (
                            <li key={index} style={{ padding: 30, margin: 15 }}>
                              <div className="feeds-left">
                                <i className={`fa ${expandedCategories[category] ? 'fa-chevron-down text-cyan' : 'fa-chevron-right text-cyan'}`}
                                  onClick={() => this.toggleCategory(category)}></i>
                              </div>
                              <div className="feeds-body">
                                <h4 className="title" onClick={() => this.toggleCategory(category)}
                                  style={{ cursor: 'pointer' }}>
                                  {category}
                                </h4>
                                {expandedCategories[category] && (
                                  <div className="d-flex flex-wrap mt-5">
                                    {groupedPermissions[category].map(permission => (
                                      <div className="fancy-checkbox mr-3" key={permission.id}>
                                        <label>
                                          <input
                                            type="checkbox"
                                            checked={formData.selectedPermissions.includes(permission.id)}
                                            onChange={(e) => this.handleCheckboxChange(permission.id, e.target.checked)}
                                          />
                                          <span>{permission.permission_name}</span>
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">

                          {loading ? (
                            <button className="btn btn-outline-primary btn-block"
                              disabled={true}
                              style={{ textAlign: "-webkit-center" }}>
                              Lütfen Bekleyin...<ReactLoading type="spin"
                                width={'24px'}
                                height={'24px'}
                                color="#268bd2"></ReactLoading>
                            </button>
                          ) :
                            <button disabled={!userHasUpdateRolePermission}
                              className="btn btn-outline-primary btn-block"
                              type="submit">
                              Kaydet
                            </button>}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(RoleDetail)));
